import { makeAutoObservable } from "mobx";

interface UserInfoType {
  [propName: string]: any;
}

export default class User {
  ticket = "";
  userName = "";
  token = "";
  AzureUserId = "";
  currentUserInfo = "";
  userInfo: UserInfoType = {};
  selectToken = "";

  constructor () {
    /**
     * state
     */
    this.ticket = window.localStorage.getItem("ticket") || "";
    this.userName = window.localStorage.getItem("name") || "";
    this.token = window.localStorage.getItem("token") || "";
    this.userInfo = {}; // 用户信息
    this.currentUserInfo = window.localStorage.getItem("userInfo") || "{}";
    this.AzureUserId = window.localStorage.getItem("userId") || "";
    this.selectToken = window.localStorage.getItem("selectToken") || "";

    makeAutoObservable(this);
  }

  /**
   * computed
   */
  // isLogin
  get isLogin () {
    // return !!this.ticket
    return this.currentUserInfo !== "" ? JSON.parse(this.currentUserInfo).token !== undefined && JSON.parse(this.currentUserInfo).token !== "" : false;
  }

  // isLogin
  get isName () {
    return !!this.userName;
  }

  get isGotUserInfo () {
    return this.currentUserInfo !== "" ? JSON.parse(this.currentUserInfo).id !== undefined && JSON.parse(this.currentUserInfo).id !== "" : false;
  }

  // userId
  get userId () {
    return JSON.parse(this.currentUserInfo).id;
  }

  get accessIdList () {
    return this.userInfo.accessIdList || [];
  }

  get userCurentInfo () {
    return this.userInfo;
  }

  get userToken () {
    return this.token;
  }

  get updateToken () {
    return this.selectToken;
  }

  /**
   * action
   */
  setTicket (val: string) {
    this.ticket = val || "";
    window.localStorage.setItem("ticket", this.ticket);
  }

  setName (val: string) {
    this.userName = val || "";
    window.localStorage.setItem("name", this.userName);
  }

  setToken (val: string) {
    this.token = val || "";
    window.localStorage.setItem("token", this.token);
  }

  setUserId (val: string) {
    this.AzureUserId = val || "";
    window.localStorage.setItem("userId", this.AzureUserId);
  }

  setUserInfo (userInfo: UserInfoType) {
    this.userInfo = userInfo || {};
    window.localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
  }

  setUpdateToken (val: string) {
    this.selectToken = val || "";
    window.localStorage.setItem("selectToken", this.selectToken);
  }
}
